import React from "react";
import { FiltersContainer } from "./FilterContainer";

export const ExploreContent = () => {
  return (
    <div>
      {/* Prefilter to show only hubName degree programs */}
      <FiltersContainer />
      {/* Print rest of results here */}
    </div>
  );
};
